export default __webpack_public_path__ + "static/media/icon_disclosure-arrow-down.c776a5fd.svg";